import React from 'react'
import Navigation from './navigation'
import SocialIcons from './socialIcons'

const Footer = () => (
  <footer>
    <div className="container footer-inner">
      <Navigation />
      <SocialIcons />
    </div>
    <div className="horizon-strip" aria-hidden="true" />
  </footer>
)

export default Footer
